import api from '@/api'
import {TeaInfoType} from '@/types/tea'
import {call, put, takeEvery} from 'redux-saga/effects'
import {userAction} from '../action'

export default function* listenSaga() {
	yield takeEvery(userAction.GET_TEA_INFO, function* () {
		try {
			const res = (yield call(api.getLoginInfo)) as TeaInfoType
			yield put({type: userAction.UPDATE_TEA_INFO, payload: res})
		} catch (error) {
			// 处理错误逻辑
			// eslint-disable-next-line no-console
			console.error(error)
		}
	})
}
